import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// CHAT_CONFIG가 설정될 때까지 대기하는 함수
function waitForConfig(maxWait = 5000): Promise<void> {
  return new Promise((resolve) => {
    if ((window as any).CHAT_CONFIG !== undefined) {
      console.log('✅ [CHAT_CONFIG] Found immediately:', (window as any).CHAT_CONFIG);
      resolve();
      return;
    }

    console.log('⏳ [CHAT_CONFIG] Waiting for config...');
    const startTime = Date.now();
    const checkInterval = setInterval(() => {
      if ((window as any).CHAT_CONFIG !== undefined) {
        clearInterval(checkInterval);
        console.log('✅ [CHAT_CONFIG] Found after wait:', (window as any).CHAT_CONFIG);
        resolve();
      } else if (Date.now() - startTime > maxWait) {
        clearInterval(checkInterval);
        console.warn('⚠️ [CHAT_CONFIG] Timeout - CHAT_CONFIG not found, using defaults');
        console.log('⚠️ [CHAT_CONFIG] Current window.CHAT_CONFIG:', (window as any).CHAT_CONFIG);
        resolve(); // 타임아웃되어도 기본값으로 진행
      }
    }, 100);
  });
}

// 앱 초기화
async function initApp() {
  // CHAT_CONFIG가 설정될 때까지 대기
  await waitForConfig();

  // chat-root 또는 root 요소 찾기 (스프링부트에서 chat-root로 사용할 수 있음)
  const rootElement = document.getElementById('chat-root') || document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// 앱 초기화 실행
initApp().catch(console.error);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
